import React, { useState } from 'react';
import { FaFileAlt, FaFilePdf, FaDownload, FaFolder, FaFilter } from 'react-icons/fa';
import '../../styles/WhitePapers.css';

function WhitePapers() {
  const [selectedYear, setSelectedYear] = useState('all');

  // White papers data organized by committee and year
  const whitePapers = {
    'Regulatory Committee': [
      {
        id: 1,
        year: 2025,
        title: 'A Brief Look at Caribbean Laws\' Readiness to Regulate Bias and Discrimination in Generative AI?',
        fileName: 'FINAL_A Brief Look at Caribbean Laws Readiness to Regulate Bias and Discrimination in Generative AI_ FINAL (2).pdf',
        filePath: process.env.PUBLIC_URL + '/assets/white_papers/FINAL_A Brief Look at Caribbean Laws Readiness to Regulate Bias and Discrimination in Generative AI_ FINAL (2).pdf',
        fileSize: 659324
      },
      {
        id: 2,
        year: 2024,
        title: 'A Historical Look at Price Regulations in the Caribbean Region and the Way Forward',
        fileName: 'Price Regulations in the Caribbean Region and the Way Forward_2 Fnl Review Cln.pdf',
        filePath: process.env.PUBLIC_URL + '/assets/white_papers/Price Regulations in the Caribbean Region and the Way Forward_2 Fnl Review Cln.pdf',
        fileSize: 1279858
      },
      {
        id: 3,
        year: 2023,
        title: 'An Initial Primer on Digital Vulnerability',
        fileName: 'Canto_digital_vulnerability_Fnl for Approval.pdf',
        filePath: process.env.PUBLIC_URL + '/assets/white_papers/Canto_digital_vulnerability_Fnl for Approval.pdf',
        fileSize: 500173
      },
      {
        id: 4,
        year: 2022,
        title: 'Is the Telecommunications Sector Rising to the Challenges? Innovation, Disruption and Changing Expectations',
        fileName: 'Is the  Telecommunications Sector Rising to the  Challenge   Innovation, Disruption and Changing Expectations 10.31.2022.pdf',
        filePath: process.env.PUBLIC_URL + '/assets/white_papers/Is the  Telecommunications Sector Rising to the  Challenge   Innovation, Disruption and Changing Expectations 10.31.2022.pdf',
        fileSize: 461874
      }
    ]
  };

  const getFileIcon = (fileName) => {
    if (fileName.toLowerCase().includes('.pdf')) {
      return <FaFilePdf className="file-icon pdf" />;
    }
    return <FaFileAlt className="file-icon" />;
  };

  const formatFileSize = (bytes) => {
    if (!bytes) return '';
    if (bytes < 1024) return bytes + ' B';
    if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(1) + ' KB';
    return (bytes / (1024 * 1024)).toFixed(1) + ' MB';
  };

  const getAvailableYears = (committee) => {
    const years = whitePapers[committee].map(paper => paper.year);
    return ['all', ...new Set(years)].sort((a, b) => {
      if (a === 'all') return -1;
      if (b === 'all') return 1;
      return b - a;
    });
  };

  const filterPapersByYear = (papers) => {
    if (selectedYear === 'all') return papers;
    return papers.filter(paper => paper.year === selectedYear);
  };

  return (
    <div className="white-papers-container">
      <div className="white-papers-header">
        <div className="white-papers-header-content">
          <h1>White Papers</h1>
          <div className="white-papers-divider"></div>
          <p className="white-papers-description">
            Access CANTO's comprehensive white papers covering critical topics in telecommunications, 
            digital policy, and regulatory frameworks across the Caribbean region.
          </p>
        </div>
      </div>

      <div className="white-papers-content">
        {Object.keys(whitePapers).map((committee) => (
          <div key={committee} className="white-papers-committee">
            <div className="committee-header">
              <h2 className="committee-title">
                <FaFolder className="committee-icon" />
                {committee}
              </h2>
              
              <div className="year-filter">
                <FaFilter className="filter-icon" />
                <select 
                  value={selectedYear} 
                  onChange={(e) => setSelectedYear(e.target.value === 'all' ? 'all' : parseInt(e.target.value))}
                  className="year-select"
                >
                  {getAvailableYears(committee).map(year => (
                    <option key={year} value={year}>
                      {year === 'all' ? 'All Years' : year}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            <div className="documents-list">
              {filterPapersByYear(whitePapers[committee]).map((paper) => (
                <a 
                  key={paper.id} 
                  href={paper.filePath} 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="document-card"
                >
                  <div className="document-icon">
                    {getFileIcon(paper.fileName)}
                  </div>
                  <div className="document-info">
                    <div className="document-year-badge">{paper.year}</div>
                    <h3 className="document-title">{paper.title}</h3>
                    <div className="document-meta">
                      <span className="document-filename">{paper.fileName}</span>
                      {paper.fileSize && (
                        <span className="document-size">{formatFileSize(paper.fileSize)}</span>
                      )}
                    </div>
                  </div>
                  <div className="document-download">
                    <FaDownload />
                  </div>
                </a>
              ))}
            </div>

            {filterPapersByYear(whitePapers[committee]).length === 0 && (
              <div className="no-papers-message">
                <p>No white papers available for {selectedYear}</p>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}

export default WhitePapers;
